import { render, staticRenderFns } from "./pictureAdd.vue?vue&type=template&id=2f0a9595&"
import script from "./pictureAdd.vue?vue&type=script&lang=js&"
export * from "./pictureAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports